export default {
  'byFinancialForm.form.employees': 'Funcionarios',
  'byFinancialForm.form.documents': 'Documentos',
  'byFinancialForm.form.deduction': '%Dedução',
  'byFinancialForm.form.situation': 'Situação',
  'byFinancialForm.form.situation.open': 'Abertos',
  'byFinancialForm.form.situation.settled': 'Liquidados',
  'byFinancialForm.form.filterByDate': 'Filtrar por data de',
  'byFinancialForm.form.filterByDate.emission': 'Emissão',
  'byFinancialForm.form.filterByDate.dueDate': 'Vencimento',
  'byFinancialForm.form.filterByDate.receipt': 'Recebimento',
};
